// components/toast/NotificationToast.js
import { Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { NAVIGATE } from 'constant/navigation';
import { useNavigate } from 'react-router-dom';

export const NotificationToast = ({ title, description, onClose, status }) => {
	const navigate = useNavigate();
	const bgSuccess = useColorModeValue('green.100', 'green.600');
	const bgError = useColorModeValue('red.100', 'red.600');
	const bgInfo = useColorModeValue('blue.100', 'blue.600');
	const bgDefault = useColorModeValue('gray.100', 'gray.700');

	const bgColor =
		{
			success: bgSuccess,
			error: bgError,
			info: bgInfo,
		}[status] || bgDefault;

	const handleClick = () => {
		navigate(NAVIGATE.REWARDS);
		onClose();
	};

	return (
		<Flex direction='column' bg={bgColor} gap={2} p={4} borderRadius={'16px'}>
			<Text fontWeight='bold'>{title}</Text>
			<Text>{description}</Text>
			<Button
				marginTop={4}
				size='sm'
				variant='brand'
				alignSelf='flex-start'
				onClick={handleClick}
			>
				Reclamar
			</Button>
		</Flex>
	);
};
